import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareVisibility } from './ShareVisibility';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SharesVisibilityForProjectFragment = { __typename?: 'Project', id: string, shares?: { __typename?: 'ShareConnection', nodes: Array<{ __typename?: 'AdHocAssetsShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null } | { __typename?: 'CollectionShare', id: string, enabled: boolean, expiration?: string | null, expiresIn?: number | null }> } | null };

export const SharesVisibilityForProject = /*#__PURE__*/ gql`
    fragment SharesVisibilityForProject on Project {
  id
  shares(page: $page, filters: $filters, orderBy: $orderBy) {
    nodes {
      ...ShareVisibility
    }
  }
}
    ${ShareVisibility}` as unknown as DocumentNode<SharesVisibilityForProjectFragment, unknown>;

        

        
export const useSharesVisibilityForProjectFragment = (
  input: string | Omit<UseFragmentOptions<SharesVisibilityForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<SharesVisibilityForProjectFragment>({
    fragment: SharesVisibilityForProject,
    fragmentName: 'SharesVisibilityForProject',
    ...options,
  });
};
  
        